import './translate_text_widget.less';

import React from 'react';

import Button from 'zoomforth_component_lib/btn_basic.jsx';
import { GlobeIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';


const TranslateTextWidget =({ shouldShowComponent, onTranslateClick })=> {
  if (!shouldShowComponent) {
    return null;
  }

  return (
    <div className="translate-text-widget">
      <Button dark fullwidth onClick={onTranslateClick}>
        <GlobeIcon /> Auto-translate
      </Button>
    </div>
  );
};

export default TranslateTextWidget;
